import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../pages/Khulega.vue')
  },
  {
    path: '/buyer-explore',
    name: 'BuyerExplore',
    component: () => import('../pages/BuyerExplore.vue')
  },
  {
    path: '/seller-onboarding',
    name: 'SellerOnboarding',
    component: () => import('../pages/SellerOnboarding.vue')
  },
  // Add other routes here
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router